import React, { useEffect, useState } from "react";
import { EyeInvisibleOutlined, EyeInvisibleTwoTone } from "@ant-design/icons";
import { Row, Space, Button, Checkbox, Divider, Input, Modal } from "antd";
import { useNavigate } from "react-router";
import { useAsyncAxios, utilAxiosWithAuth } from "../utils/customAxios";
import { useAuthDispatch, useAuthState } from "../provider/AuthProvider";
import { AlertType, useAlert } from "../provider/AlertProvider";
import { useCookies } from "react-cookie";

import * as TypeDTO from "../commons/typeDTO";
import * as Request from "../commons/request";
import * as Common from "../commons/common";
import * as String from "../commons/string";

import PageContainer from "../layout/PageContainer";
import styles from "./Login.module.css";

function WithdrawMember() {
    const navigate = useNavigate();
    const dispatch = useAuthDispatch();
    const alert = useAlert();
    const userDetail = useAuthState();

    const [cookies, setCookie, removeCookie] = useCookies(["savedId"]);
    const [isCapsLock, setIsCapsLock] = useState(false);
    const [agreeTerms, setAgreeTerms] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [password, setPassword] = useState("");

    const handleWithdraw = () => {
        requestWithdrawUser({
            email: userDetail?.user?.email,
            password: password,
        });
    };

    const requestAxiosWithdrawUser = async (data: TypeDTO.WithdrawDto) => {
        const response = await utilAxiosWithAuth().post(Request.MEMBER_WITHDRAW_URL, data);
        return response.data;
    };

    const {
        loading: loadingWithdrawUser,
        error: errorWithdrawUser,
        data: resultWithdrawUser,
        execute: requestWithdrawUser,
    } = useAsyncAxios(requestAxiosWithdrawUser);

    useEffect(() => {
        if (!resultWithdrawUser) return;

        dispatch && dispatch({ type: "LOGOUT" });
        removeCookie("savedId");

        navigate(Common.PAGE_WELCOME);
        setOpenModal(true);
        alert.setAlert(AlertType.SUCCESS, "성공", "계정 탈퇴가 완료되었습니다.");
    }, [resultWithdrawUser]);

    useEffect(() => {
        if (!errorWithdrawUser) return;

        console.log("errorUser", errorWithdrawUser);
    }, [errorWithdrawUser]);

    function onKeyDownHandler(e: any) {
        const checkCapsLock = e.getModifierState("CapsLock");
        setIsCapsLock(checkCapsLock);
    }

    return (
        <PageContainer pageBackground={"white"} contentPadding={16}>
            <Row align="middle" justify="center">
                <div className={`${styles.loginCard} container`}>
                    <p className={styles.description}>
                        지금까지 저희 서비스를 이용해 주셔서 감사합니다. 회원탈퇴를 하시더라도 회원가입이 필요하지 않은 서비스는 이전과 같이 사용하실
                        수 있습니다.
                    </p>
                    <Divider />
                    <Space style={{ marginBottom: 88 }} size={20} direction="vertical">
                        <div className={styles.textBox}>
                            <ul>
                                <Space size="small" direction="vertical">
                                    <li>
                                        통합 회원의 탈퇴란
                                        <span style={{ color: "var(--text-highlight)" }}>
                                            RUTA40 사이트, RUTA40 렌트 사이트/앱, RUTA40 디지털 키 앱
                                        </span>
                                        탈퇴를 의미합니다.
                                    </li>
                                    <li>계정 이용 내역이 있을 경우 재가입 시 고객센터 본인인증 절차가 필요할 수 있습니다.</li>
                                    <li>
                                        RUTA40 서비스 이용 내역중 디지털 키 앱 서비스 이용내역, 차량 관제 서비스 이용 내역, 차량 구매 정보는 차량
                                        구매자에 대한 유지보수를 위하여 당사에 보관될 수 있습니다.
                                    </li>
                                </Space>
                            </ul>
                        </div>
                        <Checkbox checked={agreeTerms} onChange={(e) => setAgreeTerms(e.target.checked)}>
                            안내사항을 모두 확인하였으며, 이에 동의합니다.
                        </Checkbox>

                        <Input.Password
                            onKeyDown={onKeyDownHandler}
                            className={styles.loginInput}
                            placeholder="비밀번호를 입력해 주세요."
                            iconRender={(visible) => (visible ? <EyeInvisibleTwoTone /> : <EyeInvisibleOutlined />)}
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                        {isCapsLock && (
                            <span className="capsLock" style={{ color: "#2871E6" }}>
                                Caps Lock이 켜져 있습니다.
                            </span>
                        )}
                    </Space>

                    <div className={styles.loginBtnWrapper}>
                        <Button
                            className={styles.loginBtn}
                            block
                            type="primary"
                            size="large"
                            disabled={!(agreeTerms && password.length > 0)}
                            onClick={handleWithdraw}
                        >
                            {String.withdraw}
                        </Button>
                    </div>
                    <Modal
                        className="confirmModal"
                        centered
                        key="modalSmartkeyActionError"
                        open={openModal}
                        closable={false}
                        onCancel={() => setOpenModal(false)}
                        footer={[
                            <Button block type="primary" key="back" onClick={() => setOpenModal(false)}>
                                {String.confirm}
                            </Button>,
                        ]}
                    >
                        <Row justify={"center"} align={"middle"}>
                            회원 탈퇴가 완료되었습니다.
                        </Row>
                    </Modal>
                </div>
            </Row>
        </PageContainer>
    );
}

export default WithdrawMember;
